<template>
  <modal-component ref="modalView"
        v-if="open"
        :container-width="'600px'"
        v-bind:has-close-button="completed"
        @close="onClose"
        @mask-click="onClose" >
        <template slot="header">
          <h2>{{ title }}</h2>
        </template>
        <template slot="body">
          <batch-result-view 
            ref="resultsView"
            :batch-items="batchItems" 
            v-model="customOptions"
            :hide-success="hideSuccessRows" />
        </template>
    </modal-component>
</template>
<script>
import Alerter from 'components/Alerter.vue';
import LoadingSpinner from 'components/LoadingSpinner.vue';
import BatchResult from 'components/BatchResult.vue';
import * as Enums from 'libs/enums.js';
import ModalComponent from 'components/ModalComponent.vue';
import BatchResultView from 'components/BatchResultView.vue';

export default {
  name: 'BatchResultModalView',
  components: {
    Alerter,
    'loading-spinner': LoadingSpinner,
    'batch-result': BatchResult,
    'modal-component': ModalComponent,
    'batch-result-view': BatchResultView
  },
  props: {
    customOptions: {
      default: () => {}
    }
  },
  data: function () {
    return {
      isBusy: false,
      title: '',
      batchMethod: null,
      completeMethod: null,
      items: [],
      batchItems: [],
      lockView: true,
      taggedForClose: false,
      open: false,
      hideSuccessRows: false
    };
  },
  methods: {
    showModal: function (layout) {
      this.open = true;
      this.start();
    },
    closeModal: function () {
      this.open = false;
      this.$emit('close-batch-result-modal');
    },
    showAlert: function (msg, error) {
      console.error(error);
      this.$refs.alertbox.showError(msg);
    },
    /**
     * Start the modal batch result sequence
     */
    start: async function () {
      this.lockView = true;
      this.batchItems = [];
      for (let item of this.items) {
        let batchitem = { data: item.data, result: '', description: item.description };
        this.batchItems.push(batchitem);
      }
      for (let item of this.batchItems) {
        await this.batchMethod(item);
        this.updateScroll(item);
      }
      this.lockView = false;
      if (this.completeMethod) {
        this.completeMethod(this.batchItems);
      }
    },
    hideSuccess: function () {
      this.hideSuccessRows = true;
    },
    getPercentage () {
      let self = this;
      return {
        width: self.percentage + '%'
      };
    },
    onClose (e) {
      if (this.completed) {
        this.closeModal();
      }
    },
    updateScroll(item) {
      try {
        let v = this.$refs.resultsView;
        if (v) {
          v.updateScroll(item);
        }
      } catch (err) { console.error(err); }
    }
  },
  computed: {
    modalID () {
      return this._uid + 'modal';
    },
    buttonsBlocked () {
      return this.isBusy;
    },
    completed () {
      let allcompleted = this.totalPending === 0;
      return allcompleted || false;
    },
    totalPending () {
      let amount = this.batchItems.filter(x => x.result === Enums.ResultEnum.PENDING);
      return amount ? amount.length : 0;
    },
    percentage () {
      let self = this;
      let total = self.batchItems.length;
      let done = self.batchItems.filter(x => x.result !== '' && x.result !== Enums.ResultEnum.PENDING).length;
      return Math.round((done / total) * 100);
    }
  }
};
</script>

<style lang="scss" scoped>
.batch-result-list {
  padding: 0px;
}
.result-summary {
  .success {
    font-weight: bold;
    color: green;
    background-color: transparent;
  }
  .ignored {
    font-weight: bold;
    color: black;
    background-color: transparent;
  }
  .failed {
    font-weight: bold;
    color: red;
    background-color: transparent;
  }
}
.scrollable-wrapper {
  overflow-y: scroll;
  overflow-x: hidden;
  max-height: 350px;
  padding: 0px;
}

</style>
